import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { CheckCircle, Home, Phone, Package } from 'lucide-react'
import { useRestaurant } from '../contexts/RestaurantContext'
import { useSession } from '../contexts/SessionContext'

export default function OrderConfirmation() {
  const { orderId } = useParams<{ orderId: string }>()
  const { restaurantInfo } = useRestaurant()
  const { isSessionValid } = useSession()
  const [orderNumber, setOrderNumber] = useState<string>('')

  useEffect(() => {
    // orderId is actually the order_number from the URL
    if (orderId) {
      setOrderNumber(orderId)
    }
  }, [orderId])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Order Placed!</h1>
          <p className="text-gray-600">
            Thank you for your order. We'll prepare it right away.
          </p>
        </div>

        {orderNumber && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 mb-1">Order Number</p>
            <p className="text-xl font-bold text-gray-900">{orderNumber}</p>
          </div>
        )}

        {restaurantInfo?.phone_number && (
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-2">Need help?</p>
            <a
              href={`tel:${restaurantInfo.phone_number}`}
              className="flex items-center justify-center gap-2 text-amber-500 hover:text-amber-600"
            >
              <Phone className="w-4 h-4" />
              {restaurantInfo.phone_number}
            </a>
          </div>
        )}

        <div className="space-y-3">
          {isSessionValid() && (
            <Link
              to="/my-orders"
              className="block w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
            >
              <Package className="w-5 h-5" />
              View My Orders
            </Link>
          )}
          <Link
            to="/"
            className="block w-full bg-amber-500 text-white py-3 rounded-xl font-semibold hover:bg-amber-600 transition-colors flex items-center justify-center gap-2"
          >
            <Home className="w-5 h-5" />
            Back to Menu
          </Link>
        </div>
      </div>
    </div>
  )
}

